import React from 'react';
import styled from 'styled-components';

function ContactItem({icon, title, contact1, contact2}) {
    return (
        <ContactItemStyled>
            <div className="left-content">
                <p>
                    {icon}
                </p>
            </div>
            <div className="right-content">
                <h6>{title}</h6>
                <p>{contact1}</p>
                <p>{contact2} </p>
            </div>
        </ContactItemStyled>
    )
}

const ContactItemStyled = styled.div`
    padding: 1.5rem 2rem;
    background-color: var(--background-dark-grey);
    display: flex;
    align-items: center;
    
    @media screen and (max-width: 520px) {
        padding: 1rem;
    }

    @media screen and (max-width: 360px) {
        padding: 0.5rem;
    }

    &:not(:last-child) {
        margin-bottom: 2rem;
    }
    
    .left-content {
        padding: 1.8rem;
        border: 1px solid var(--border-color);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 1.5rem;
        svg {
            font-size: 2.3rem;
        }
    }

    .right-content {
        h6 {
            color: var(--white-color);
            font-size: 1.2rem;
            padding-bottom: 0.6rem;
        }

        p {
            padding: 0.1rem 0;
        }
    }
`;

export default ContactItem;
